import script from "./PermissionForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PermissionForm.vue?vue&type=script&setup=true&lang=js"

import "./PermissionForm.vue?vue&type=style&index=0&id=3a4b7029&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a4b7029"]])

export default __exports__